import { z } from 'zod';

export const schema = z.object({
  type: z.string(),
  output: z.string(),
  context: z.object({}),
});
